import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

export default function CustomExpired2ResendDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-expired-resend"
        label="Resend"
        variant="contained"
        size="medium"
        color="success"
        sx={{
          marginLeft: "10px",
          width: "120px",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-expired-resend"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="xs"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const reqUrl = `applications/actions/expired/toResend`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: {},
            });
            if (
              response &&
              (response.status == "200" || response.code == "200")
            ) {
              successNotify("Data saved successfully");
              if (props?.cb) {
                props.cb("To Notify");
              }
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Resend" />
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            Are your sure move this application {appId} to "To Notify
            Applications" page ?
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Note : Click the "Confirm" button to delete Loan Closing Document
              file too.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Resend" color="success" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
